import React from 'react';

// Define the type for the icon prop, matching the original type
type IconProp = string | React.FC<React.SVGProps<SVGSVGElement>>;

type IconComponentProps = {
  icon: IconProp;
};

/**
 * Renders a dynamic icon.
 * If 'icon' is a string, it renders an <i> tag (for font icons).
 * If 'icon' is a React Component (SVG), it renders the component.
 */
const IconComponent: React.FC<IconComponentProps> = ({ icon }) => {
  // Logic moved from ServiceItemComp
  if (typeof icon === 'string') {
    return <i className={`${icon} fs-2 text-dark`}></i>;
  }

  // If it's not a string, it's an SVG component.
  // We use JSX syntax (which compiles to React.createElement).
  const SvgIcon = icon;
  return <SvgIcon className='fs-2 text-dark' style={{ width: '1.5em', height: '1.5em' }} />;
};

export default IconComponent;